import React from 'react';
import '../template-file-css/document-file-template.css';


export const ACTS_MultisystemicTherapyPreScreening = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='ACTS_MultisystemicTherapyPreScreening' className='file-pdf-document'>
            <div className='file-template'>
                <p><h3>MULTISYSTEMIC THERAPY PRE SCREENING</h3></p>
                <p><h4>Entrance Criteria</h4></p>
                <p><h4>The recipient is eligible for this service when:</h4></p>

                <p className='w-750'>
                    <ol type="A">
                        <li>There is an Axis I or II diagnosis present, other than a sole diagnosis of Developmental
                            Disability.<br />
                            <b>AND</b>
                        </li>
                        <li>The youth should be between the ages of 7 through 17.
                            <br />
                            <b>AND</b>
                        </li>
                        <li>The youth displays willful behavioral misconduct (e.g., theft, property destruction, assault,
                            communicating verbal threats, other status offense, truancy or substance use/abuse or
                            juvenile sex offense).
                            <br />
                            <b>AND</b>
                        </li>
                        <li>The youth is at imminent risk of out-of-home placement or is currently in out-of-home
                            placement due to delinquency and reunification is imminent within 30 days of referral.
                            <br />
                            <b>AND</b>
                        </li>
                        <li>The youth has a caregiver that is willing to assume long term parenting role and caregiver
                            who is willing to participate with service providers for the duration of the treatment.
                            <br />
                            <b>AND</b>
                        </li>
                    </ol>
                </p>



            </div>
        </form>

    )
}  
